import type { createFetchClient } from '@bank/fetch';

import type { BenefitProgramsResponse, CustomerCookieResponse } from './types';
import { CUSTOMER_COOKIE_QUERY } from './queries';

type FetchClient = ReturnType<typeof createFetchClient>;

/** Fetches benefit programs for the current customer. */
export const fetchBenefitPrograms = (client: FetchClient, apiRoot: string) =>
  client.get<BenefitProgramsResponse>({
    url: `${apiRoot}/benefits/programs/customers`,
  });

/** Fetches customer core + consent information via GraphQL. */
export const fetchCustomerCookieData = (client: FetchClient, apiRoot: string) =>
  client.post<CustomerCookieResponse>({
    url: `${apiRoot}/customer/graph/graphql`,
    body: { query: CUSTOMER_COOKIE_QUERY },
  });
